var _defs, _circle, _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPausewarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F4F4F8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.053 72.083c-11.304 0-20.469-9.072-20.469-20.264 0-11.191 9.165-20.264 20.47-20.264 11.304 0 20.468 9.073 20.468 20.264 0 11.192-9.164 20.264-20.469 20.264zm-.284-51.005C32.776 21.078 19 34.716 19 51.538 19 68.364 32.776 82 49.769 82S80.538 68.362 80.538 51.54 66.762 21.078 49.769 21.078z",
    fill: "#DFDDE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.053 69.62c-11.304 0-20.469-9.072-20.469-20.264 0-11.191 9.165-20.264 20.47-20.264 11.304 0 20.468 9.073 20.468 20.264 0 11.192-9.164 20.264-20.469 20.264zm-.284-51.004C32.776 18.617 19 32.255 19 49.079s13.776 30.461 30.769 30.461 30.769-13.638 30.769-30.461-13.776-30.462-30.769-30.462z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.36 29.086c-11.118 0-20.164 8.956-20.164 19.965s9.046 19.965 20.165 19.965 20.165-8.956 20.165-19.965S61.48 29.086 50.36 29.086zm.002 40.535c-11.456 0-20.776-9.227-20.776-20.57 0-11.342 9.32-20.57 20.776-20.57s20.776 9.228 20.776 20.57c0 11.343-9.32 20.57-20.776 20.57zm-.286-51.015c-16.8 0-30.466 13.532-30.466 30.164 0 16.633 13.667 30.164 30.466 30.164 16.798 0 30.466-13.531 30.466-30.164 0-16.632-13.668-30.164-30.466-30.164zm0 60.932C32.942 79.538 19 65.735 19 48.768 19 31.804 32.94 18 50.077 18c17.136 0 31.076 13.803 31.076 30.769 0 16.966-13.94 30.769-31.076 30.769z",
    fill: "#18122B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.83 38.83c-.23-.716 3.22-5.033 6.014-8.305l-2.073-3.587c-1.198-2.073-4.193-2.073-5.39 0l-2.827 4.89-2.827 4.892c-1.198 2.072.3 4.663 2.695 4.663h5.12l-.06-.03s-.273-1.346-.652-2.523zM43.923 64.154c-1.869 0-3.384-1.477-3.384-3.3V40.992c0-1.822 1.515-3.3 3.384-3.3 1.87 0 3.385 1.478 3.385 3.3v19.862c0 1.822-1.515 3.3-3.385 3.3zM55.614 64.154c-1.87 0-3.384-1.477-3.384-3.3V40.992c0-1.822 1.515-3.3 3.384-3.3 1.87 0 3.385 1.478 3.385 3.3v19.862c0 1.822-1.515 3.3-3.385 3.3z",
    fill: "#DFDDE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.307 62.306c-1.87 0-3.385-1.477-3.385-3.3V39.144c0-1.822 1.516-3.3 3.385-3.3 1.87 0 3.384 1.478 3.384 3.3v19.862c0 1.823-1.515 3.3-3.384 3.3z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.617 35.835c-1.694 0-3.073 1.346-3.073 2.999v19.87c0 1.654 1.379 2.999 3.073 2.999 1.695 0 3.073-1.345 3.073-2.998V38.834c0-1.654-1.378-2.999-3.073-2.999zm-.003 26.473c-2.036 0-3.692-1.616-3.692-3.603v-19.87c0-1.987 1.656-3.604 3.692-3.604 2.036 0 3.693 1.617 3.693 3.603v19.871c0 1.987-1.657 3.603-3.693 3.603z",
    fill: "#18122B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.001 62.306c-1.87 0-3.384-1.477-3.384-3.3V39.144c0-1.822 1.515-3.3 3.384-3.3 1.87 0 3.385 1.478 3.385 3.3v19.862c0 1.823-1.516 3.3-3.385 3.3z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.305 35.835c-1.694 0-3.073 1.346-3.073 2.999v19.87c0 1.654 1.379 2.999 3.073 2.999 1.695 0 3.073-1.345 3.073-2.998V38.834c0-1.654-1.378-2.999-3.073-2.999zm.004 26.473c-2.036 0-3.692-1.616-3.692-3.603v-19.87c0-1.987 1.656-3.604 3.692-3.604 2.036 0 3.692 1.617 3.692 3.603v19.871c0 1.987-1.656 3.603-3.692 3.603z",
    fill: "#18122B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.615 40.155h-5.752c-2.437 0-3.96-2.59-2.742-4.663l2.876-4.891 2.876-4.891c1.219-2.073 4.266-2.073 5.484 0l2.876 4.89 2.876 4.892c1.22 2.073-.304 4.663-2.742 4.663h-5.752z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.308 24.756c-1.034 0-1.96.525-2.478 1.405l-5.752 9.791a2.741 2.741 0 000 2.811 2.841 2.841 0 002.477 1.406H85.06c1.034 0 1.96-.526 2.478-1.406a2.742 2.742 0 000-2.81l-5.753-9.792a2.841 2.841 0 00-2.477-1.405zM85.06 40.77H73.556a3.448 3.448 0 01-3.008-1.706 3.327 3.327 0 010-3.412l5.753-9.792a3.449 3.449 0 013.007-1.706c1.255 0 2.38.638 3.007 1.706l5.753 9.792a3.327 3.327 0 010 3.412 3.449 3.449 0 01-3.007 1.706z",
    fill: "#18122B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.308 34.614c-.68 0-1.23-.489-1.23-1.091v-4.587c0-.603.55-1.091 1.23-1.091.68 0 1.231.488 1.231 1.09v4.588c0 .602-.551 1.09-1.23 1.09zM80.539 36.462a1.23 1.23 0 11-2.461 0 1.23 1.23 0 012.461 0z",
    fill: "#4D3BD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPausewarning);
export default __webpack_public_path__ + "static/media/pause.warning.1628a1ae.svg";
export { ForwardRef as ReactComponent };